import { render } from "./view-settings.vue?vue&type=template&id=49f6b998"
import script from "./view-settings.vue?vue&type=script&lang=js"
export * from "./view-settings.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__